
import { defineComponent } from "vue";
import AgNav from "@/components/ag-nav/index.vue";
import { Roles, Rules } from "@/helpers/enums/Roles";
import { store } from "@/store";

export default defineComponent({
  name: "Sidebar",
  data() {
    return {
      store: store,
    };
  },
  components: { AgNav },
  props: {
    items: {
      type: Array,
    },
  },
  mounted() {
    // const company = store.getters.company;
    // const index = this.navItems.findIndex((item) => item.title === "assets");
    // const path = `/assets/company/${company.companyGuid}/sites`;
    // this.navItems[index].link = path;
  },
});
